import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { useFilterValue, useWillConstrain } from '@morningtrain/react-filters'
import { ButtonTabs } from 'ui/buttons'
import withTranslations from 'support/hoc/withTranslations'

function BooleanFilter (props) {
  const {
    name,
    label,
    defaultValue = null,
    onChange = () => {},
    allowNull = false
  } = props

  const [value, setValue] = useFilterValue(name, defaultValue)

  useWillConstrain(name, value)

  const handleChange = (newValue) => {
    if (newValue === value && allowNull) {
      newValue = null
    }

    onChange(newValue)
    setValue(newValue)
  }

  return (
    <div className='form-element'>
      <label htmlFor=''>{label}</label>
      <ButtonTabs classNames={props.className} size={props.size} fullWidth={props.fullWidth}>
        <button
          key={1}
          type='button'
          className={(true === value) ? 'active' : 'inactive'}
          onClick={() => handleChange(true)}
        >
          <span className='flex items-center justify-center'>
            Yes
          </span>
        </button>
        <button
          key={0}
          type='button'
          className={(false === value) ? 'active' : 'inactive'}
          onClick={() => handleChange(false)}
        >
        <span className='flex items-center justify-center'>
          No
        </span>
        </button>
      </ButtonTabs>
    </div>
  )
}

BooleanFilter.defaultProps = {
  label: null,
  only: null
}

BooleanFilter.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  icon: PropTypes.node,
  defaultValue: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool
}

export default observer(withTranslations(BooleanFilter))
